import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import IHCI_2023 from "./../../Images/IHCI_2023.jpg";
import IHCI_2023_back from "./../../Images/IHCI_2023_back.jpg";

export const Home = () => {
  return (
    <>
      <section class="main-containers" style={{height:"600px !important"}}>
        <div class="page-headers" style={{height:"600px !important"}}>
          <h1 style={{ color: "white" }}>15th International Conference on IHCI-2023</h1>
          <h3 style={{ color: "white" }}>
            Daegu, Korea, November 08 - 10, 2023
          </h3>
        </div>
      </section>
      <section className="container">
        <div className="home-video-box" style={{ alignItems: "center" }}>
          <iframe
            className="youtube-video-box a"
            title="video"
            src="https://www.youtube.com/embed/D8rUQ-fEHcE"
          ></iframe>
          <div
            className="youtube-video-box b"
            style={{ textAlign: "left !important" }}
          >
            <div className="heading">
              <h1>IMPORTANT DATES</h1>
            </div>
            <h5>Workshop/Tutorial Proposal: June 15, 2023</h5>
            <h5>Paper Submission Deadline: August 15, 2023</h5>
            <h5>Notification of Acceptance: September 25, 2023</h5>
            <h5>Camera Ready Paper Submission: September 30, 2023</h5>
            <h5>Conference Date: November 08-10, 2023</h5>
            <br />
            <h4>For IHCI 2023 Conference submissions</h4>
            <h5>you can register/login to your CMT site at:</h5>
            <Link to="https://cmt3.research.microsoft.com/IHCI2023">
              <h5 style={{color:"blue"}}>https://cmt3.research.microsoft.com/IHCI2023</h5>
            </Link>
          </div>
        </div>
        <hr className="hr-style" />

        <div className="heading">
          <h1>IHCI 2023</h1>
        </div>
        <h5>Dear Esteemed Participants,</h5>
        <h5 style={{ marginLeft: "40px !important", color: "#5A5A5A" }}>
          Welcome to IHCI 2023, the annual International Conference on
          Intelligent Human-Computer Interaction!{" "}
        </h5>
        <h5 style={{ color: "#5A5A5A" }}>
          With great pleasure, we invite you to join us in this exceptional
          gathering of researchers, educators, and young professionals from
          around the world.
        </h5>
        <h5>
          Since its establishment in 2008, the Intelligent Human-Computer
          Interaction (IHCI) society has been dedicated to advancing
          human-centered technology, cognitive computing, and humanities
          studies. Our mission is to foster innovation and collaboration through
          research and experimental development initiatives. And this year, our
          conference is powered by the theme of "AI-Powered IHCI," exploring the
          exciting intersection of artificial intelligence and human-computer
          interaction.
        </h5>
        <h5>
          IHCI 2023 serves as a vibrant platform for the presentation of
          cutting-edge research results and technological advancements.
          Engineers and scientists from various disciplines, including
          artificial intelligence, signal processing, computer vision, and
          human-computer interaction, will converge to share their insights,
          collaborate, and push the boundaries of knowledge. This unique blend
          of expertise creates an environment where theoretical, practical, and
          applicational aspects of the field can be explored, leading to
          groundbreaking discoveries and innovations.
        </h5>
        <h5>
          As the foremost worldwide gathering in the field, IHCI has attracted
          top researchers, graduate students, research think tanks, and industry
          technology developers. Together, we aim to tackle the emerging
          research challenges arising from the intricate interaction between
          machine intelligence and human intelligence. We believe that by
          participating in IHCI, you will be able to actualize your goals in
          HCI, leading to greater success in business and contributing to the
          betterment of society as a whole.
        </h5>
        <h5>
          The field of Human-Computer Interaction has experienced significant
          progress in recent years, resulting in diverging trends. While some
          conferences focus on specific topics like Interaction Design and
          User-Centered Design, others embrace new areas such as Computing with
          Words, Prosocial Agents Development, and Attention-based Applications.
          IHCI stands apart by addressing the intelligence and human-computer
          interaction issues at the intersection of these trends. This holistic
          approach allows us to explore the forefront of research and bridge the
          gap between academia and industry.
        </h5>
        <h5>
          By becoming a member of the IHCI society, you will gain access to the
          latest conferences and events conducted by our community. We aspire to
          be a leading community of researchers, educators, and young
          professionals, setting new benchmarks in research and advancing the
          understanding of Intelligent Human Computer Interaction and Cognitive
          Computing.
        </h5>
        <h5>
          We look forward to your participation in IHCI 2023 and the valuable
          contributions you will bring to our vibrant community. Together, let's
          shape the future of AI-powered IHCI and create technology that
          enhances the human experience.
        </h5>
        <h5>Warmest regards,</h5>
        <h5>Prof. Wan-Young Chung, General Chair, IHCI 2023</h5>
        <h5>Prof. Dhananjay Singh, Conference Chair, IHCI 2023</h5>
        <br />
        <hr className="hr-style" />
        <br />
        <div className="home-video-box">
          <div className="youtube-video-box a">
            <img
              width="100%"
              height="100%"
              src={IHCI_2023}
              alt="IHCI-2023"
            ></img>
          </div>
          <div className="youtube-video-box b">
            <img
              width="100%"
              height="100%"
              src={IHCI_2023_back}
              alt="IHCI-2023"
            ></img>
          </div>
        </div>
        <hr className="hr-style" />
      </section>
    </>
  );
};
